import React, { useState,useEffect, useRef } from "react";
import Webcam from "react-webcam";
// import jsQR from "jsqr";

const videoConstraints = {
  width: 540,
  facingMode: "environment"
};

// let nextId = 0;
const CameraBasic = () => {
  const webcamRef = useRef(null);
  const [url, setUrl] = React.useState(null);
  const [arrURL, setArrURL] = React.useState([]);
  const [nextId, setNextId] = useState(0);

  const [count, setCount] = useState(0)
      function add(){
        setCount(count+1)  //try count+1 ,not count=count+1
      }

  const capturePhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    // console.log("imageSrc",imageSrc);
            // setArtists( // Replace the state
            //   [ // with a new array
            //     ...artists, // that contains all the old items
            //     { id: nextId++, name: name } // and one new item at the end
            //   ]
            // );
    console.log("nextId()",nextId);
    setArrURL([...arrURL, { id: nextId, src: imageSrc }]);
    // nextId++;
    setNextId(nextId+1);
    console.log("arrURL",arrURL);
    setUrl(imageSrc);
  }, [webcamRef]);

  const onUserMedia = (e) => {
    console.log(e);
  };

  console.log("arrURL.src",arrURL.src);
  console.log("nextId",nextId);
  console.log("count",count);
  return (
    <>
      <button type="button" onClick={add}>+</button>
      {/*url && (
        <div>
          <img src={url} alt="Screenshot" style={{maxWidth:'300px', maxHeight:'300px'}} />
        </div>
      )*/}
      {arrURL? arrURL.map ((arrURL, index) => (
        <div key={arrURL.id} className={"col-4 p-2"}>
          <div>
            <img src={arrURL.src} alt="Screenshot" style={{maxWidth:'300px', maxHeight:'300px'}} />
          </div>
        </div>
      )):null
      }
      <Webcam
        ref={webcamRef}
        audio={false}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
        onUserMedia={onUserMedia}
      />
      <button type="button" className="btn btn-primary mt-2 text-nowrap" onClick={capturePhoto}>Capture</button>
      <button type="button" className="btn btn-primary mt-2 text-nowrap" onClick={() => setUrl(null)}>Refresh</button>
    </>
  );
};

export default CameraBasic;